module.exports = __webpack_public_path__ + "static/media/10.a7a06638.gif";